import { methodsText } from '@lib/constants/methods';
import { ButtonPrimary } from '@modules/common/components/form/buttons/button-primary';
import { useFormikContext } from 'formik';
import { handleDeliveryMethodSelection } from '../handles/handle-delivery-method-selection';

type DeliveryMethodsItemsProps = {
  methods: string[];
};

export const DeleveryMethods = (props: DeliveryMethodsItemsProps) => {
  const { methods } = props;

  const form = useFormikContext<any>();
  const field = form.getFieldProps('deliveryMethod');

  return (
    <div className="card__method__items gap-2 flex flex-row">
      {methods.map((item, _index) => (
        <div key={item}>
          <ButtonPrimary
            type="button"
            size="medium"
            active={field.value === item}
            onClick={() => handleDeliveryMethodSelection({ item, field, form })}
            className="!py-1"
          >
            {methodsText[item] as string}
          </ButtonPrimary>
        </div>
      ))}
    </div>
  );
};
